import type { ComponentProps } from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { tokens } from '../theme/tokens';

type ClerkAppearance = NonNullable<ComponentProps<typeof ClerkProvider>['appearance']>;

const { colors } = tokens;

/**
 * Clerk appearance mapped to the Redbax dark design tokens.
 * Applied once on the ClerkProvider so it cascades to every Clerk
 * component (SignIn, UserButton, etc.).
 */
export const clerkAppearance: ClerkAppearance = {
  baseTheme: dark,
  variables: {
    colorPrimary: colors.redAccent,
    colorBackground: colors.surface,
    colorInputBackground: colors.surfaceRaised,
    colorText: colors.textPrimary,
    colorTextSecondary: colors.textSecondary,
    colorInputText: colors.textPrimary,
    colorDanger: colors.redAccent,
    colorSuccess: colors.greenOk,
    colorWarning: colors.amberWarn,
    borderRadius: '0.5rem',
  },
  elements: {
    card: {
      backgroundColor: colors.surface,
      border: `1px solid ${colors.border}`,
    },
  },
};
